import styled from 'styled-components';

/**
 * Fallback for the app-wide `GenericErrorBoundary` in `pages/_app.tsx`.
 *
 * The copy is deliberately neutral — see the JSX comment below and
 * `docs/DINER_ERROR_COPY.md`.
 *
 * **Critical constraint: this renders OUTSIDE `<ThemeProvider>`.** The boundary in
 * `_app.tsx` opens before the provider, so anything rendered here has no
 * styled-components theme. It must therefore use literal CSS values only: themed
 * components such as `StyledPrimaryButton` dereference `theme.forms.*` /
 * `theme.buttons.*` and would throw inside the fallback itself, replacing the
 * crash screen with a blank page. `app-crash-fallback.test.tsx` renders this
 * without any provider to lock that in.
 */
export function AppCrashFallback() {
  return (
    <StyledErrorContainer>
      {/*
       * Neutral by design: this boundary wraps every page, including login,
       * sign-up and account, so it must not claim an order or a restaurant.
       * Order-scoped crash copy lives in the page-owned fallbacks
       * (store, checkout, order-confirmation). See docs/DINER_ERROR_COPY.md.
       */}
      <h1>This page didn&apos;t load properly</h1>
      <p>Refresh the page to try again.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Refresh Page
      </button>
    </StyledErrorContainer>
  );
}

const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  height: 70vh;
  h1 {
    margin-bottom: 0px;
  }
  p {
    margin-top: 5px;
    margin-bottom: 30px;
  }
  button {
    background-color: #000;
    color: #fff;
    padding: 8px 20px;
    border-radius: 5px;
    cursor: pointer;
  }
`;
